import { createTrackingUtils } from "../index";
import { UIConfidenceLevel } from "@flights/types";

const utils = createTrackingUtils({
  name: "flights_apex_web_flex_rec_on_fd_v2",
  stages: {
    main: 1,
    mdot: 2,
    ddot: 3,
    medium_confidence: 4,
    high_confidence: 5,
    very_high_confidence: 6
  },
  goals: {},
  defaultStage: 1
});

const trackStages = (isMobile: boolean, confidenceLevel?: UIConfidenceLevel) => {
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (confidenceLevel === "MEDIUM") utils.stages.medium_confidence();
  if (confidenceLevel === "HIGH") utils.stages.high_confidence();
  if (confidenceLevel === "VERY_HIGH") utils.stages.very_high_confidence();
};

export default { trackStages, ...utils };
